import { useTranslation } from 'react-i18next';

import { Button } from '@any-ui-react/core';
import { useModals } from '@any-ui-react/modals';

export const InstructionPreview = ({ instruction }: { instruction?: string } = {}) => {
  const { t } = useTranslation(['shared']);
  const { openModal } = useModals();

  if (!instruction) return null;

  return (
    <div>
      <div className="text-gray-7 line-clamp-3 overflow-hidden text-ellipsis whitespace-pre-wrap">
        {instruction}
      </div>
      <div className="flex justify-end">
        <Button
          className="p-0"
          type="button"
          variant="transparent"
          onClick={() =>
            openModal({
              modalId: 'instruction-preview-modal',
              children: <div className="whitespace-pre-wrap">{instruction}</div>,
            })
          }
        >
          {t('shared.button.more', { ns: 'shared' })}
        </Button>
      </div>
    </div>
  );
};
